import $eventBus from '@/utils/event-bus';
import { removeEmpty } from '@/utils/helpers';

/**
 * @param {AxiosStatic} axios
 * @param {Store} store
 * @param {VueRouter} router
 */
export default (axios, store, router) => {
	axios.interceptors.request.use(
		(config) => {
			config.params = config.params && removeEmpty(config.params);

			return config;
		},
		(err) => {
			return Promise.reject(err);
		},
	);
	axios.interceptors.response.use(
		function (response) {
			return response;
		},
		async function (error) {
			/* eslint-disable */
			// return Promise.reject(error);
			return Promise.reject({
				error,
				default: (message = 'حدث خطأ ما', details = true) => {
					$eventBus.$emit(
						'show-snackbar',
						message,
						{
							error: true,
						},
						details &&
						error.response &&
						error.response?.status && (
							error.response.data.message ||
							error.response.data.title
						)
					);
				},
			});
		},
	);
};
